import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PatternItem } from '@components/molecules/academicLandingPage/patternItem';

export const PatternItemContainer = styled(Box)`
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
`;

export const PatternTitle = styled(Typography)`
  font-size: 24px;
  line-height: 1;
  font-weight: 500;
  color: #000000de;
  margin-bottom: 8px;
`;

export const PatternDescription = styled(Typography)`
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  color: #00000099;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  dl,
  dt,
  dd {
    margin: 0px;
  }
`;
